import { Button } from '@material-ui/core';
import styled from '@emotion/styled';
import Image from '@base/Image';
import Tooltip from '@base/Tooltip/Tooltip';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import useWindowSize from '@hooks/useWindowSize';
import { useEffect, useState } from 'react';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import pushRoute from '@utils/pushRoute';
import useFirstRenderSkip from '@hooks/useFirstRenderSkip';
import usePaymentNudgeStore from '@stores/headerNudge';
import { segment } from '@actions/analytics';
import {
  REFERRAL_TOPBAR_TOUCHPOINT,
  REFERRAL_TOUCHPOINT_CLICKED
} from '@constants/segment';
import { localStorageAvailable } from '@utils/localStorage';
import useIsReferralRevampEnabled from '@cont/Settings/Referral/ReferralV2/useIsReferralRevampEnabled';
import ReferWinHeaderPill from '@cont/Settings/Referral/ReferralV2/components/ReferWinHeaderPill';

const HeaderReferralToolTip = styled(Tooltip)`
  z-index: 1200;
  .MuiTooltip-tooltip {
    padding: ${Spacings.SPACING_0B};
    border-radius: ${Spacings.SPACING_2B};
  }
  ${mediaQuery.uptoMobile} {
    &.MuiTooltip-popper {
      z-index: 1100;
    }
    .MuiTooltip-tooltip {
      padding: ${Spacings.SPACING_4B};
      margin-right: -${Spacings.SPACING_3B};
    }
  }
`;
const ReferralWrapper = styled.div`
  ${({ $isLoggedIn }) => {
    return $isLoggedIn
      ? `width:${Spacings.SPACING_8B}; height:${Spacings.SPACING_8B};`
      : `width:${Spacings.SPACING_10B}; height:${Spacings.SPACING_10B};`;
  }}
  position: relative;
  margin-right: ${Spacings.SPACING_4B};
  margin-left: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_0B} ${Spacings.SPACING_2B};
    width: ${Spacings.SPACING_8B};
    height: ${Spacings.SPACING_8B};
  }
`;

const ReferralButtonWrapper = styled(Button)`
  display: none;
  &.MuiButton-label {
    width: ${Spacings.SPACING_6B};
  }
  &.show-referral-button {
    display: contents;
    width: ${Spacings.SPACING_8B};
    height: ${Spacings.SPACING_8B};
  }
`;

const CoachmarkContainer = styled.div`
  padding: ${Spacings.SPACING_4B};
  width: 220px;
`;
const CoachmarkTextWrapper = styled.div`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Spacings.SPACING_4B};
  line-height: ${Spacings.SPACING_6B};
  text-align: center;
  letter-spacing: -0.005em;
  color: var(--color-i-white);
`;
const ReferralNudge = ({ isExpanded }) => {
  const { isMobile } = useWindowSize();
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { isRevampEnabled: isReferralRevampEnabled } =
    useIsReferralRevampEnabled();
  const [openToolTip, setOpenToolTip] = useState(false);
  const [isAlreadyVisible, setIsAlreadyVisible] = useState(false);

  const { isPaymentNudge } = usePaymentNudgeStore();

  useEffect(() => {
    if (localStorageAvailable()) {
      if (localStorage.getItem('openHeaderToolTip') === 'true') {
        setIsAlreadyVisible(true);
      }
    }
  }, []);

  useFirstRenderSkip(() => {
    if (localStorageAvailable()) {
      const storeToolTipShown =
        localStorage.getItem('storeToolTipShown') ||
        localStorage.getItem('storeTooltipStatus') === 'clicked';
      if (!isPaymentNudge && storeToolTipShown) {
        localStorage.setItem('openHeaderToolTip', 'true');
        setOpenToolTip(true);
      } else {
        setOpenToolTip(false);
      }
    }
  }, [isLoggedIn, isMobile, isPaymentNudge]);

  const handleRedirect = () => {
    segment.track(REFERRAL_TOUCHPOINT_CLICKED, {
      last_primary_source_section: REFERRAL_TOPBAR_TOUCHPOINT
    });
    const path =
      isReferralRevampEnabled || isLoggedIn
        ? '/settings/referral'
        : '/referral';
    pushRoute(path, path);
  };

  const tooltipContent = (
    <CoachmarkContainer>
      <CoachmarkTextWrapper>
        Refer & earn rewards upto ₹25,000
      </CoachmarkTextWrapper>
    </CoachmarkContainer>
  );
  useEffect(() => {
    if (openToolTip && !isAlreadyVisible && !isPaymentNudge && !isMobile) {
      const timeout = setTimeout(() => {
        setOpenToolTip(false);
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [isAlreadyVisible, isMobile, isPaymentNudge, openToolTip]);

  if (isReferralRevampEnabled) {
    return <ReferWinHeaderPill onClick={handleRedirect} />;
  }

  return (
    <HeaderReferralToolTip
      open={openToolTip && !isAlreadyVisible && !isPaymentNudge && !isMobile}
      title={tooltipContent}
      backgroundColor="var(--color-accent-blue)"
    >
      <ReferralWrapper $isLoggedIn={isLoggedIn}>
        <ReferralButtonWrapper
          className={isExpanded ? '' : 'show-referral-button'}
          onClick={handleRedirect}
        >
          <Image src="newGoalHeaderGift.svg" layout="fill" alt="avatar" />
        </ReferralButtonWrapper>
      </ReferralWrapper>
    </HeaderReferralToolTip>
  );
};
export default ReferralNudge;
